<template>

    <v-section name="Custom Recipient" :expanded="expanded">
        <v-input size="sm" placeholder="person@mycompany.com" :model="action.recipient" @input="updateRecipient($event)" />
    </v-section>

</template>

<script>

import Section from './Section';

export default {

    components: {
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        action() {
            return this.$store.getters['builder/action'];
        },

    },

    methods: {

        updateRecipient(recipient) {
            let action = { ...this.action };
            this.$set(action, 'recipient', recipient);
            this.$store.commit('builder/setAction', action);
        },

    },

}

</script>